import {ButtonProps} from '@gravity-ui/uikit';

import {QuestionMarkupItem} from '../QuestionMarkup';

export const buttonProps: ButtonProps = {
    view: 'outlined',
    size: 'l',
};

export const fileQuestionPositions = [
    QuestionMarkupItem.Label,
    QuestionMarkupItem.Comment,
    QuestionMarkupItem.Image,
    QuestionMarkupItem.Control,
];
